module.exports = __webpack_public_path__ + "img/mac.1f9b521.png";